export function buildManagersListTableHeaders({ t }) {
  return [
    {
      value: "image",
      label: t("page.catalog.image"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[5rem] min-w-[5rem]",
      disabled: true,
    },
    {
      value: "id",
      text: t("page.managers.id"),
      thClass: "w-[3rem]",
      tdClass: "max-w-[2rem] min-w-[3rem]",
      disabled: true,
    },
    {
      value: "user",
      text: t("page.managers.user"),
      thClass: "w-[5rem]",
      tdClass: "max-w-[10rem] min-w-[10rem]",
    },
    {
      value: "contacts",
      text: t("page.managers.contacts"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[10rem] min-w-[7rem]",
    },
    {
      value: "region",
      text: t("page.managers.region"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[10rem] min-w-[7rem]",
    },
    {
      value: "status",
      text: t("page.managers.status"),
      thClass: "w-[7rem]",
      tdClass: "max-w-[9rem] min-w-[7rem]",
    },
  ];
}
